<form [formGroup]="conversationTypeForm" (ngSubmit)="onSubmit()">
  <div class="form-header">
    <div class="form-title">Konversation erstellen</div>
  </div>
  <div class="form-content">
    <div class="row">
      <div class="input-field">
        <orbit-form-field
          [label]="'SHARED.CREATE_CONVERSATION_FORM.ID_LABEL' | translate"
          [name]="'conversation-id'"
          [controller]="conversationID" />
        <div class="input-field-description">
          {{ 'SHARED.CREATE_CONVERSATION_FORM.ID_DESCRIPTION' | translate }}
        </div>
      </div>
      <div class="input-field">
        <orbit-form-field
          [label]="'SHARED.CREATE_CONVERSATION_FORM.DESCRIPTION_LABEL' | translate"
          [name]="'conversation-description'"
          [controller]="conversationDescription" />
        <div class="input-field-description">
          {{ 'SHARED.CREATE_CONVERSATION_FORM.DESCRIPTION_DESCRIPTION' | translate }}
        </div>
      </div>
    </div>
    <div class="participants-wrapper" formArrayName="participants">
      <orbit-form-field-header
        [label]="'SHARED.CREATE_CONVERSATION_FORM.PARTICIPANT_LABEL' | translate"
        [tooltip]="'SHARED.CREATE_CONVERSATION_FORM.PARTICIPANT_TOOLTIP' | translate" />
      @for (participant of participants.controls; track $index; let i = $index) {
        <div [formGroupName]="i" class="participant-container">
          <orbit-form-multiple-field [fields]="participantFields(i)" />
          <orbit-button
            class="remove-participant-button"
            [icon]="faTrash"
            size="default"
            (click)="removeParticipant(i)"
            *ngIf="participants.length > 1" />
        </div>
      }
      <orbit-button
        class="add-participant-button"
        outlined
        [icon]="faPlus"
        size="small"
        [label]="'SHARED.CREATE_CONVERSATION_FORM.ADD_PARTICIPANT' | translate"
        (click)="addParticipant()" />
    </div>
    <div class="input-field">
      <orbit-form-field-header
        [label]="'SHARED.CREATE_CONVERSATION_FORM.TYPE_LABEL' | translate"
        [tooltip]="'SHARED.CREATE_CONVERSATION_FORM.TYPE_TOOLTIP' | translate" />
      <div class="input-field-extended-checkboxes">
        @for (type of conversationTypes; track type.id) {
          <orbit-form-extended-checkbox
            [type]="'radio'"
            [item]="type.id"
            [description]="type.description"
            [subtitle]="
              type.displayNameSharedByUsers
                ? ('SHARED.CREATE_CONVERSATION_FORM.FAVORITE_CONVERSATION_TYPE.DISPLAY_NAME'
                    | translate) +
                  ' ' +
                  type.displayNameSharedByUsers
                : null
            "
            [name]="'conversation-type'"
            [value]="type.id"
            [showFavorite]="true"
            [favorite]="type.id === this.preselectedConversationTypeId"
            [titleForFavorite]="
              'SHARED.CREATE_CONVERSATION_FORM.FAVORITE_CONVERSATION_TYPE.SET' | translate
            "
            [titleForUnFavorite]="
              'SHARED.CREATE_CONVERSATION_FORM.FAVORITE_CONVERSATION_TYPE.REMOVE' | translate
            "
            [controller]="conversationType"
            (favoriteChange)="this.onConversationTypeFavoriteClicked(type.id)" />
        }
      </div>
    </div>
    <div class="input-field">
      <orbit-form-field-header
        [label]="'SHARED.CREATE_CONVERSATION_FORM.DATA_LABEL' | translate"
        [button]="true"
        [icon]="getDataIcon()"
        (buttonClick)="handleExpand()" />
      @if (dataExpanded) {
        <orbit-input
          [inputType]="'textarea'"
          [name]="'conversation-data'"
          class="input-field-large-textarea"
          [textareaAutosizeLimit]="{ minRows: 4, maxRows: 20 }"
          [controller]="conversationData" />
      }
    </div>
  </div>
  @let errors = error ? error() : null;
  <div class="error-wrapper">
    @for (error of errors; track error.id) {
      <orbit-message
        [message]="error.message ?? error.code | translate"
        [severity]="'error'"
        [list]="error.errors"
        [listKey]="'message'" />
    }
  </div>
  <div class="form-footer">
    <div class="button-wrapper">
      <orbit-button
        [inputId]="'cancel-button'"
        [label]="'SHARED.CREATE_CONVERSATION_FORM.CANCEL_LABEL' | translate"
        [flat]="true"
        [styleClass]="'cancel-button'"
        [disabled]="formSubmitting()"
        (click)="this.dialogButtonClicked.emit({ eventType: 'CANCEL' })" />
      <orbit-button
        [inputId]="'save-button'"
        type="'submit'"
        [disabled]="!conversationTypeForm.valid || formSubmitting()"
        [label]="'SHARED.CREATE_CONVERSATION_FORM.SAVE_LABEL' | translate"
        [styleClass]="'save-button'" />
    </div>
  </div>
</form>
